// generated by master:generate — do not edit
export const generatedEn: Record<string, string> = {
  "col.billing-term": "Billing term",
  "col.billing-term.plural": "Billing term",
  "col.cargo-package": "Cargo package",
  "col.cargo-package.plural": "Cargo package",
  "col.cargo-type": "Cargo type",
  "col.cargo-type.plural": "Cargo type",
  "col.container": "Container",
  "col.container.plural": "Container",
  "col.fee-type": "Fee type",
  "col.fee-type.plural": "Fee type",
  "col.lead-status": "Lead status",
  "col.lead-status.plural": "Lead status",
  "col.lead-type": "Lead type",
  "col.lead-type.plural": "Lead type",
  "col.leadtime": "Leadtime",
  "col.leadtime.plural": "Leadtime",
  "col.shipment-status": "Shipment status",
  "col.shipment-status.plural": "Shipment status",
  "col.transport": "Transport",
  "col.transport.plural": "Transport",
  "col.truck-fee": "Truck fee",
  "col.truck-fee.plural": "Truck fee",
  "col.truck-payload": "Truck payload",
  "col.truck-payload.plural": "Truck payload",
  "col.truck-type": "Truck type",
  "col.truck-type.plural": "Truck type",
  "col.vn-centroid": "Vn centroid",
  "col.vn-centroid.plural": "Vn centroid",
  "field.cargo_id": "Cargo id",
  "field.cargo_package": "Cargo package",
  "field.cargo_package_id": "Cargo package id",
  "field.cargo_payload_max": "Cargo payload max",
  "field.cargo_payload_min": "Cargo payload min",
  "field.cargo_type": "Cargo type",
  "field.credit_term": "Credit term",
  "field.fee_type": "Fee type",
  "field.fee_type_id": "Fee type id",
  "field.hours": "Hours",
  "field.id2_admin_name": "Id2 admin name",
  "field.in_day": "In day",
  "field.lead_status": "Lead status",
  "field.lead_status_id": "Lead status id",
  "field.lead_type": "Lead type",
  "field.lead_type_id": "Lead type id",
  "field.leadtime": "Leadtime",
  "field.leadtime_id": "Leadtime id",
  "field.mm": "Mm",
  "field.owner_abbreviation": "Owner abbreviation",
  "field.point_id": "Point id",
  "field.prefix": "Prefix",
  "field.shipment_status": "Shipment status",
  "field.shipping_line": "Shipping line",
  "field.status_id": "Status id",
  "field.transport_short": "Transport short",
  "field.transport_type_id": "Transport type id",
  "field.truck_fee_code": "Truck fee code",
  "field.truck_fee_name": "Truck fee name",
  "field.truck_fee_name_vn": "Truck fee name vn",
  "field.truck_id": "Truck id",
  "field.truck_size": "Truck size",
  "field.truck_type": "Truck type",
  "field.year": "Year",
}
